export interface OrganizationSettings {
    textColor?: string;
    titleColor?: string;
    backgroundColor?: string;
    tableHeaderColor?: string;
    tableFooterColor?: string;
    backgroundColorPY?: string;
}
